import { postToApi, getToRails } from "venuescanner-js/services/api";
import controllers from "venuescanner-js/services/controllers";
import {
  networkPermissions,
  venuePermissions,
} from "venuescanner-js/constants/role_permissions_es";
const adminBoolean = false;
export const authenticationService = {
  user: null,
  admin: null,
  requested: {
    admin: false,
  },
  init: function () {
    if (window.data && window.data.user) {
      this.user = { ...window.data.user };
    }
    if (this.updateNavbar) this.updateNavbar();
  },
  setUserInfo: function (data) {
    data.user.joined = data.user.created_at;
    window.data = {
      ...(window.data || {}),
      ...{
        viewerID: data.user._id,
        viewerToken: data.access_token,
        user: data.user,
      },
    };
    this.user = { ...(this.user || {}), ...window.data.user };
  },
  isAdmin: function () {
    if (this.requested.admin) {
      return {
        then: (cb) => {
          cb(adminBoolean);
        },
      };
    } else {
      return this.getAdmin();
    }
  },
  getAdmin: function () {
    return new Promise((resolve, reject) => {
      if (this.requested.admin) return resolve(adminBoolean);
      this.requested.admin = true;
      if (window && window.data && window.data.viewerAdminToken) {
        postToApi("users/superme", {}, { asAdmin: true }).then((details) => {
          if (details.user) {
            this.admin = details.user;
            if (this.admin.role === "admin") return resolve(true);
          }
          resolve(false);
        });
      } else {
        resolve(false);
      }
    });
  },
  requiresAction: function () {
    return this.user.just_an_invite;
  },
  getDetails: async function () {
    const { data } = await controllers.user.me.get(); // getToApi('users/me')
    return data;
  },
  hasPermission: function (permission, { venue = null, network = null }) {
    if (network && network._id) network = network._id;
    if (venue && venue._id) venue = venue._id;
    // console.log(permission, venue, network)
    if (networkPermissions[permission] && !network) {
      throw new Error("Network must be provided for a network permission");
    }
    if (venuePermissions[permission] && !venue) {
      throw new Error("Venue must be provided for a venue permission");
    }
    // console.log(networkPermissions[permission], network, this.user.networkRole)

    if (
      networkPermissions[permission] &&
      network &&
      this.user.networkRole &&
      this.user.networkRole.length
    ) {
      const networkRole = this.user.networkRole.find((nr) => {
        return nr.network === network.valueOf();
      });
      if (networkRole && networkRole.role && networkRole.role.permissions) {
        return networkRole.role.permissions[permission];
      }
    }
    if (
      venuePermissions[permission] &&
      venue &&
      this.user.venueRole &&
      this.user.venueRole.length
    ) {
      const venueRole = this.user.venueRole.find((nr) => {
        return nr.venue === venue.valueOf();
      });
      if (venueRole && venueRole.role && venueRole.role.permissions) {
        return venueRole.role.permissions[permission];
      }
    }
    return false;
  },
  findInarray: function (list) {
    return list.find((u) => {
      return u._id.toString() === this.user._id.toString();
    });
  },
  isLoggedIn: function () {
    return !!(this.user && this.user._id);
  },
  updatePlace: async function (place) {
    if (this.isLoggedIn()) {
      if (
        place.id &&
        this.user &&
        (!this.user.place ||
          !this.user.place.id ||
          this.user.place.id !== place.id)
      ) {
        try {
          await postToApi("user/set-place", { place });
          this.refreshSession();
        } catch (e) {}
      }
    }
  },
  refreshSession: async function () {
    const data = await getToRails("auth/refresh");
    if (data.user && window.data && window.data.user) {
      window.data.user = { ...window.data.user, ...data.user };
      this.user = { ...window.data.user };
    }
    // console.log(data)
  },
};
if (typeof window !== "undefined") {
  // setTimeout(() => {
  authenticationService.init();
  // })
}
